
























































































import {
  defineComponent,
  computed,
  ref,
  reactive,
  getCurrentInstance
} from "@vue/composition-api";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import RelatedLinksFooter from "@/components/Organisms/RelatedLinksFooter/index.vue";

import { removeZendeskLastAuthDate } from "@/helpers/zendesk-helper";
import { ApiRequest } from "@/api/types";
import { useStore } from "@/store";
import { useRouter } from "@/router";
// import { useRoute, useRouter } from "@/router"; // TODO: vue-router4移行時に書き換える

export default defineComponent({
  name: "SignIn",
  components: {
    Heading,
    TextField,
    Button,
    ButtonConfig,
    RelatedLinksFooter
  },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  // TODO: $router, $store, $routeはVue3では利用できないので別途対応を行う
  setup() {
    const auth = reactive<ApiRequest.SignIn>({
      email: "",
      password: ""
    });
    const store = useStore();
    const router = useRouter();
    // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
    // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
    // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
    const route = getCurrentInstance()?.proxy.$root.$route; // TODO: vue-router4移行時に削除してuseRouteで生成したrouteにアクセスさせる
    // const route = useRoute(); // TODO: vue-router4移行時に書き換える
    const loading = ref(false);
    const messages = ref<string[]>([]);

    const ariaLabel = computed(() => {
      if (loading.value) {
        return "送信中";
      }
      return "";
    });

    const disabled = computed(() => {
      if (auth.email && auth.password) {
        return false;
      }
      return true;
    });

    const sso = computed(() => {
      // SSOログイン要求かどうかを判別する。SSOするシステムの名称が指定される。
      // 指定される可能性のある文字列は以下の通り。
      // - zendesk
      return route?.query["sso"] ?? "";
    });

    const zendeskReturnTo = computed<string | undefined>(() => {
      // zendesk側で指定されたログイン後に遷移するURLが指定される。
      // 既存のredirectToではOCCのアプリケーション内にしか遷移することができないため、別で用意しました。
      // zendeskからのSSOログイン要求の場合のみ指定されます。
      const zendeskReturnTo = route?.query["zendeskReturnTo"];
      if (typeof zendeskReturnTo === "string") {
        return zendeskReturnTo;
      }

      return undefined;
    });

    const handlePassWordReissue = () => {
      router.push({ name: "PasswordReissue" }).catch(err => err);
    };

    const handleSubmit = () => {
      if (auth.email && auth.password) {
        loading.value = true;
        store.dispatch("domains/user/signIn", auth).then(
          () => {
            removeZendeskLastAuthDate();

            if (sso.value === "zendesk") {
              const zendesk_sso_callback_url = `${process.env["VUE_APP_API_ORIGIN"]}/api/cloud/recruitment_planning/v1/partner_users/zendesk_sso_callback`;
              if (zendeskReturnTo.value) {
                location.href = `${zendesk_sso_callback_url}?return_to=${encodeURIComponent(
                  zendeskReturnTo.value
                )}`;
              } else {
                location.href = zendesk_sso_callback_url;
              }
              return;
            }

            router
              .push({
                name: "Home",
                query: {
                  isLoggedIn: "true",
                  redirectTo: route?.query["redirectTo"]
                }
              })
              .catch(err => err);
          },
          error => {
            loading.value = false;
            messages.value = [];
            const errorMessages: any = error.response.data.errors.messages;
            errorMessages.forEach((item: string) => messages.value.push(item));
          }
        );
      }
    };

    const signUpLinkClick = () => {
      location.href = `${process.env["VUE_APP_API_ORIGIN"]}/partner_applications/new`;
    };

    return {
      auth,
      loading,
      messages,
      ariaLabel,
      disabled,
      sso,
      zendeskReturnTo,
      handlePassWordReissue,
      handleSubmit,
      signUpLinkClick
    };
  }
});
